import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import SectionLoading from '../common/SectionLoading';
import SectionLoadingError from "../common/SectionLoadingError";
import { logUI } from "../../api/andyliticsApi";
import MessageWithIcon from '../common/MessageWithIcon';


const DetailsInsuranceBreakdown = props => {
    const { benefitDetails } = props;   
    const benefits = benefitDetails && benefitDetails[0] ? benefitDetails[0] : null;    
    const payerInfoList = benefitDetails[0].appliedInsurances.length > 0 ? benefitDetails[0].appliedInsurances : null;    
    const hasMultiplePayers = !(benefits && benefits.hasMultipleInsuranceApplied && benefits.hasMultipleInsuranceApplied.toLowerCase() === "false");
    const appliedInsurances = (benefits && benefits.appliedInsurances) ? benefits.appliedInsurances : null;
    const hasPayerInfo = payerInfoList && payerInfoList.length > 0;
    const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
    const toggleInsuranceModal = () => setInsuranceModalOpen(!insuranceModalOpen);

    useEffect(() => {
        //console.info(`detailsInsuranceBreakdown ${insuranceModalOpen}`, props);
    }, [insuranceModalOpen]);

    const InsuranceBreakdownModal = () => {
        return (
            <div className={`insurance-modal `}>
                <div className="label pb-2">What is the difference between a family & individual deductible or out of pocket maximum?</div>
                <ul>
                    <li>
                        If you have an individual health plan, you pay for any care you need up to your deductible. 
                        After that, your out-of-pocket expenses will go down since you’ll usually only pay for copays and/or co-insurance until your out-of-pocket maximum is met. 
                        Once your spending reaches your out-of-pocket maximum, your plan pays 100% of your covered health care expenses for the rest of the year. 
                        Both the deductible and out-of-pocket maximum reset each year.
                </li>
                    <li>
                        If you have a family health plan, each family member has their own individual deductible and out-of-pocket maximum, 
                        as well as a family deductible and out-of-pocket maximum, which can be met when anyone on your family plan pays for a covered health care service.
                </li>
                    <li>
                        When your family deductible is met, the entire family will only pay the copay or co-insurance. 
                        After your family out-of-pocket maximum is met, your health plan starts covering all costs for covered health care services for the whole family for the remainder of the benefit year.
                </li>
                    <li>Please contact your health or insurance plan for more details on your plan and benefit details.</li>
                </ul>
            </div>
            );
    }

    try {
        console.info(`DetailsInsuranceBreakdown benefitDetails`, benefitDetails);
        if (benefitDetails.length > 0 && benefitDetails[0].payerBenefitsDetails && hasPayerInfo) {
            const payerBenifit = benefitDetails[0].payerBenefitsDetails;
            const indWidth = obligationFullfilled(payerBenifit.deductibleMetInd, payerBenifit.deductibleInd,'indWidth');
            const famWidth = obligationFullfilled(payerBenifit.deductibleMetFam, payerBenifit.deductibleFam,'famWidth');
            const outOfPocketIndWidth = obligationFullfilled(payerBenifit.outOfPocketMetInd, payerBenifit.outOfPocketMaxInd,'outOfPocketIndWidth');
            const outOfPocketFamWidth = obligationFullfilled(payerBenifit.outOfPocketMetFam, payerBenifit.outOfPocketMaxFam,'outOfPocketFamWidth');
            const indDeductibleStatus = hiddenCls(payerBenifit.deductibleMetInd) === '' && hiddenCls(payerBenifit.deductibleInd) === '' ;
            const famDeductibleStatus = hiddenCls(payerBenifit.deductibleMetFam) === '' && hiddenCls(payerBenifit.deductibleFam) === '' ;
            const indOutOfPocketStatus = hiddenCls(payerBenifit.outOfPocketMetInd) === '' && hiddenCls(payerBenifit.outOfPocketMaxInd) === '' ;
            const famOutOfPocketStatus = hiddenCls(payerBenifit.outOfPocketMetFam) === '' && hiddenCls(payerBenifit.outOfPocketMaxFam) === '' ;
            console.info(`detailsInsuranceBreadkdown hidden values indDeductibleStatus '${indDeductibleStatus}' famDeductibleStatus '${famDeductibleStatus}' indOutOfPocketStatus '${indOutOfPocketStatus}' famOutOfPocketStatus '${famOutOfPocketStatus}'`, (indOutOfPocketStatus === '' || indDeductibleStatus === '' || famOutOfPocketStatus === '' || famDeductibleStatus === ''));
            return <div className={`row estimate-details-panel ${(props.isSelfPay )?'hidden':''}`}>
                <div className="col">
                    <React.Fragment>
                        <div className="row">
                        <div className="col"><h4 className="heading">Insurance Breakdown:<span className="icon-question" onClick={() => toggleInsuranceModal()} /></h4></div>
                        </div>
                        {(hasMultiplePayers) &&
                            <div className="row insurance-details m-0">
                                <MessageWithIcon
                                    icon="icon-info-filled">
                                    This breakdown only shows your primary insurance details for
                            {` ${appliedInsurances[0]}`}. Please contact
                            your insurance providers for more details on your benefits.
                        </MessageWithIcon>
                            </div>
                        }
                    </React.Fragment>
                    
                    {indDeductibleStatus && <div className="row item">
                        <div className="col">
                            <div className="row">
                                <div className="col label insurance">Individual Deductible</div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="bar-container">
                                        <div className="bar-display" style={{ width: indWidth }}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 bar-label">Met: {formatMoney(payerBenifit.deductibleMetInd)}</div>
                                <div className="col-6 bar-label text-right">Max: {formatMoney(payerBenifit.deductibleInd)}</div>
                            </div>
                        </div>
                    </div>}
                    {famDeductibleStatus && <div className="row item">
                        <div className="col">
                            <div className="row">
                                <div className="col label insurance">Family Deductible</div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="bar-container">
                                        <div className="bar-display" style={{ width:famWidth }}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 bar-label">Met: {formatMoney(payerBenifit.deductibleMetFam)}</div>
                                <div className="col-6 bar-label text-right">Max: {formatMoney(payerBenifit.deductibleFam)}</div>
                            </div>
                        </div>
                    </div>}
                    {indOutOfPocketStatus && <div className="row item">
                        <div className="col">
                            <div className="row">
                                <div className="col label insurance">Individual Out-Of-Pocket MAX</div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="bar-container">
                                        <div className="bar-display" style={{ width: outOfPocketIndWidth }}></div>
                                    </div></div>
                            </div>
                            <div className="row">
                                <div className="col-6 bar-label">Met: {formatMoney(payerBenifit.outOfPocketMetInd)}</div>
                                <div className="col-6 bar-label text-right">Max: {formatMoney(payerBenifit.outOfPocketMaxInd)}</div>
                            </div>
                        </div>
                    </div>}
                    {famOutOfPocketStatus &&<div className="row item">
                        <div className="col">
                            <div className="row">
                                <div className="col label insurance">Family Out-Of-Pocket MAX</div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="bar-container">
                                        <div className="bar-display" style={{ width: outOfPocketFamWidth }}></div>
                                    </div></div>
                            </div>
                            <div className="row">
                                <div className="col-6 bar-label">Met: {formatMoney(payerBenifit.outOfPocketMetFam)}</div>
                                <div className="col-6 bar-label text-right">Max: {formatMoney(payerBenifit.outOfPocketMaxFam)}</div>
                            </div>
                        </div>
                    </div>}
                </div>
                <Modal isOpen={insuranceModalOpen} toggle={toggleInsuranceModal} centered={true}>
                    <ModalHeader toggle={toggleInsuranceModal}>Insurance Breakdown</ModalHeader>
                    <ModalBody> {InsuranceBreakdownModal()}</ModalBody>
                </Modal>
            </div>;
        }  else {
            return (benefitDetails.length === 0 || (benefitDetails.length > 0 && !benefitDetails[0].payerBenefitsDetails)) ?
                <div className={`row estimate-details-panel ${props.isSelfPay ? 'hidden' : ''}`}>
                    <div className="col">
                        <div className="row item">
                            <div className="col"><h4 className="heading">Insurance Breakdown:<span className="icon-question" onClick={() => toggleInsuranceModal()} /></h4></div>
                        </div>
                        <div className={`row estimate-details-panel no-insurance-error ${props.isSelfPay ? 'hidden' : ''}`}>
                            <div className="col">
                                <MessageWithIcon
                                    icon="icon-input-error">
                                    <div className="">We are having trouble loading your insurance breakdown right now. Please call our Pre-Registration department
                                    to access your insurance breakdown at <a className="phone-link" href={"tel:" + props.customerServicePhone}>{props.customerServicePhone}</a></div>
                                </MessageWithIcon>
                            </div>
                        </div>
                    </div>
                    <Modal isOpen={insuranceModalOpen} toggle={toggleInsuranceModal} centered={true}>
                        <ModalHeader toggle={toggleInsuranceModal}>Insurance Breakdown</ModalHeader>
                        <ModalBody> {InsuranceBreakdownModal()}</ModalBody>
                    </Modal>
                </div>:<React.Fragment></React.Fragment>;
        }
    } catch (ex) {
        logUI("MBHWeb.UI.Estimates.detailsInsuranceBreakdown", new Date(), `estimateDetails/${props.msgId}`, props, 'ERROR', ex.message); 
        console.error(`detailsInsurranceBreakdown exception`, ex);
        return <React.Fragment>{ ex}</React.Fragment>;
    }
}
const hiddenCls = (val, isMax) => {//hide section for bad or dont care data. Met value can not be empty, Max can not be empty or 0
    isMax = isMax ? isMax : false;
    console.info(`detailsInsuranceBreakdown hiddenCls val '${val}'`);
    let cls = '';
    try {
        if ((val==='' || isNaN(Number.parseInt(val)))||(val===0 && isMax)) {
            cls = 'hidden';
        }
    } catch (e) { cls = 'hidden'; }
    return cls;
}
const formatMoney = (amount) => {
    console.info(`detailsInsuranceBreakdown formatMoney amount '${amount}'`);
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return formatter.format(amount);
}

const obligationFullfilled = (amountMet, amountMax, amntName) => {
    console.info(`detailsInsuranceBreaddown obligationFullfilled ${amntName} amountMet '${amountMet}' amountMax '${amountMax}'`);
    let n = '100%';
    let nn;
    const met = Number(amountMet);
    const max = Number(amountMax);
    if (isNaN(met) || isNaN(met) || met === 0) {
        n = '0%';
    }else if (!isNaN(met) && !isNaN(met) && met <= max) {
        nn = (met / max).toFixed(2);
        n = (nn * 100) + '%';
    }
    console.info(`detailsInsuranceBreaddown obligationFullfilled ${amntName} returning '${n}'`);
    return n;

}

function mapStateToProps(state) {
    return {
        customerServicePhone: state.session.serverData.pricingPreRegPhone,
    };
}
export default connect(mapStateToProps)(DetailsInsuranceBreakdown);